import {
	Combobox,
	ComboboxInput,
	ComboboxContent,
	ComboboxEmpty,
	ComboboxList,
	ComboboxItem,
	Icon,
} from '@hydrodigital/design-system';
import type { ComboboxOption } from '@hydrodigital/combobox';

type CountrySearchComboboxProps = {
	options: ComboboxOption[];
	value: string;
	onSelect: (value: string) => void;
};

const CountrySearchCombobox = ({ options, value, onSelect }: CountrySearchComboboxProps) => {
	return (
		<Combobox size='small' items={options} value={value} onValueChange={onSelect}>
			<ComboboxInput
				placeholder="Search"
				leftIcon={<Icon name="search" size="s" hoverable={false} color="#078CB3" />}
				dropdownIcon={<></>}
				showClear={false}
			/>
			<ComboboxContent>
				<ComboboxEmpty>No regions found.</ComboboxEmpty>
				<ComboboxList>
					{(item) => (
						<ComboboxItem key={item.value} value={item}>
							{item.label}
						</ComboboxItem>
					)}
				</ComboboxList>
			</ComboboxContent>
		</Combobox>
	);
};

export default CountrySearchCombobox;
